import styled from 'styled-components';
import { SkeletonLoader } from '@/components/SkeletonLoader/SkeletonLoader';
import { Button } from '@/components/UI/Button/Button';
import { Tooltip } from '@/components/Tooltip';

const MIN_CARD_WIDTH = 138;

export const Grid = styled.div`
  display: grid;
  gap: 15px 13px;
  grid-template-columns: repeat(1, minmax(${MIN_CARD_WIDTH}px, 1fr));

  @media (min-width: 320px) {
    grid-template-columns: repeat(2, minmax(${MIN_CARD_WIDTH}px, 1fr));
  }

  @media (min-width: 544px) {
    grid-template-columns: repeat(3, minmax(${MIN_CARD_WIDTH}px, 1fr));
  }

  @media (min-width: 744px) {
    grid-template-columns: repeat(4, minmax(${MIN_CARD_WIDTH}px, 1fr));
  }

  @media (min-width: 950px) {
    grid-template-columns: repeat(2, minmax(${MIN_CARD_WIDTH}px, 1fr));
  }

  @media (min-width: 1005px) {
    grid-template-columns: repeat(3, minmax(${MIN_CARD_WIDTH}px, 1fr));
  }

  @media (min-width: 1200px) {
    grid-template-columns: repeat(4, minmax(${MIN_CARD_WIDTH}px, 1fr));
  }
`;

export const CardWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 8px;
  height: 100%;
  width: 100%;
  > a {
    flex: 1;
  }
`;

export const ActionsSkeleton = styled.div`
  display: flex;
  gap: 3px;
`;

export const PrimaryActionSkeleton = styled(SkeletonLoader).attrs({
  height: 40,
  borderRadius: 14,
})`
  flex: 1;
`;

export const MenuActionSkeleton = styled(SkeletonLoader).attrs({
  width: 40,
  height: 40,
  borderRadius: 14,
})`
  flex-shrink: 0;
`;

export const ArchiveButtonBox = styled.div`
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 2;
`;

export const ArchiveTooltip = styled(Tooltip)`
  && {
    width: auto;
    max-width: max-content;
    padding: 8px 10px;
    border-radius: 9px;
    font-size: 12px;
    white-space: nowrap;
  }
`;

export const ArchiveButton = styled(Button).attrs({
  appearance: 'secondaryWhite',
  hasPadding: false,
  height: 30,
  shape: 'square',
})`
  border-radius: 50%;
  width: 30px;
`;
